import { Box, Checkbox, FormControlLabel } from "@mui/material";
import Text from "@/components/Text";
import {
  MINI_COG_BORDER_COLOR,
  MINI_COG_VERSION_COLUMNS,
  MINI_COG_VERSION_LABEL,
  MINI_COG_WORD_VERSIONS,
} from "../initial-f2f-mini-cog-constant";

export interface MiniCogWordVersionsProps {
  selected: string[];
  onChange: (selected: string[]) => void;
}

const MiniCogWordVersions = ({
  selected,
  onChange,
}: MiniCogWordVersionsProps) => {
  const toggle = (word: string, isChecked: boolean) =>
    onChange(
      isChecked ? [...selected, word] : selected.filter((it) => it !== word)
    );

  return (
    <Box
      display="grid"
      gridTemplateColumns={{
        xs: "repeat(2, minmax(0, 1fr))",
        md: `repeat(${MINI_COG_VERSION_COLUMNS}, minmax(0, 1fr))`,
      }}
      sx={{
        border: `1px solid ${MINI_COG_BORDER_COLOR}`,
        borderRadius: 1,
        "& > div + div": { borderLeft: `1px solid ${MINI_COG_BORDER_COLOR}` },
      }}
    >
      {MINI_COG_WORD_VERSIONS.map((words, index) => (
        <Box key={words.join("-")} display="flex" flexDirection="column" p={1}>
          <Text size={13} fontWeight="bold" textAlign="center" mb={0.5}>
            {`${MINI_COG_VERSION_LABEL} ${index + 1}`}
          </Text>
          {words.map((word) => (
            <FormControlLabel
              key={word}
              sx={{ m: 0 }}
              control={
                <Checkbox
                  size="small"
                  checked={selected.includes(word)}
                  onChange={(e) => toggle(word, e.target.checked)}
                />
              }
              label={<Text size={13}>{word}</Text>}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default MiniCogWordVersions;
